"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Prescriptions = void 0;
const data_1 = require("./data");
class Prescriptions {
    constructor(prescriptionHeader, bilan) {
        this.formatPrescriptions = (prescriptionHeader, bilan) => prescriptionHeader.prescriptions.map(prescription => {
            const temp = data_1.PRESCRIPTION_STATE_LABEL.get(prescription?.last_prescription_status?.state);
            let tempStateDisplay;
            if (temp) {
                tempStateDisplay = temp(prescription?.prescription_type === "MEDICATION", bilan);
            }
            else {
                tempStateDisplay = bilan.en_cours === 'no' ? 'Non approuvée en intervention' : 'Envoi en cours...';
            }
            const payloadParse = JSON.parse(prescription.payload);
            return {
                ...prescription,
                payloadParse,
                label: prescription?.prescription_type === "MEDICATION" ? `${payloadParse.label} - ${payloadParse.dosage} ${payloadParse.unit} - ${payloadParse.route}` : `${payloadParse.geste}`,
                commentDisplay: prescription?.last_prescription_status?.comment
                    ? `${prescription?.last_prescription_status?.comment}`
                    : prescription?.comment
                        ? `${prescription?.comment}`
                        : 'Pas de commentaire',
                stateDisplay: tempStateDisplay,
                administrateur_full_name: prescription?.last_prescription_status?.administrateur_full_name
            };
        });
        this.completed_at = prescriptionHeader.completed_at ?? '';
        this.id = prescriptionHeader.id;
        this.numero_rpps = prescriptionHeader.numero_rpps;
        this.prescriptions = this.formatPrescriptions(prescriptionHeader, bilan);
        this.shared_at = prescriptionHeader.shared_at;
        this.signature = prescriptionHeader.signature;
        this.user = prescriptionHeader.user;
        this.vehicle_target = prescriptionHeader.vehicle_target;
        this.procuration = prescriptionHeader.procuration;
        this.procuration_name = prescriptionHeader.procuration_name;
        this.asu = prescriptionHeader.asu;
        this.prescription_qualification = prescriptionHeader.prescription_qualification;
        return this;
    }
}
exports.Prescriptions = Prescriptions;
